import { TASK_REPEAT_HOUR } from '@shared/task-repeat';
import { formatDate, projectTimezone } from '@/lib/formatters';

/** The zone the server schedules Repeats in: the project's, or UTC when none is set (as the worker does). */
export const repeatZone = projectTimezone;

/** When a Repeat next brings a task back: "Mon 5 Oct, 08:00" (the year too when it isn't this one). */
export function repeatNextLabel(at: string | Date): string {
  const date = new Date(at);
  const timeZone = repeatZone();
  const thisYear = formatDate(date, { year: 'numeric', timeZone }) === formatDate(new Date(), { year: 'numeric', timeZone });
  const day = formatDate(date, { weekday: 'short', day: 'numeric', month: 'short', ...(thisYear ? {} : { year: 'numeric' }), timeZone });
  return `${day}, ${String(TASK_REPEAT_HOUR).padStart(2, '0')}:00`;
}
